export default __webpack_public_path__ + "9052c75387065f76bb3436b7e4ce12cd.svg";